export const isLoadingUserDataSelector = state => state?.userInfo?.isLoading
export const userRolesSelector = state => state?.userInfo?.userRoles
export const userInfoSelector = state => state?.userInfo?.userInfo
export const userRealRolesSelector = state => state?.userInfo?.userRealRoles

